import Image from "next/image";

export const ShortDescription = () => {
  return (
    <div className="relative mt-4 flex w-full items-center justify-center rounded-xl bg-[#FEE7E4] p-6 text-center font-montserrat shadow-sm md:mt-3 lg:px-8">
      <div className="absolute -top-6 left-4 flex items-center gap-3 rounded-xl bg-white px-4 py-2 text-base font-semibold shadow-md">
        <Image
          src="/icons/score-check/ShortDesciption.svg"
          width={28}
          height={28}
          alt="date icon"
          className="h-6 w-6"
        />
        <span className="text-base">Short Description</span>
      </div>

      <div className="mx-auto flex max-w-4xl flex-col items-center justify-center gap-1 px-4 py-6">
        <h3 className="text-lg font-semibold text-[#B94444] lg:text-xl xl:text-2xl">
          Short Description Found
        </h3>

        <div className="flex items-center justify-center">
          <Image
            src="/assets/resumeScore/ShortDesciption.png"
            alt="illustration"
            width={200}
            height={130}
            className="object-contain"
          />
        </div>

        <p className="max-w-3xl text-center text-xs text-gray-700 lg:text-sm">
          Short descriptions can sometimes lack detail and clarity.
        </p>
      </div>
    </div>
  );
};

// bg-[#0F8D041C]
